import useUser from "hooks/use-user";
import type { UserPermission } from "types/user";

const usePermission = ((permission: UserPermission | UserPermission[]) => {
  const user = useUser();

  if (Array.isArray(permission)) {
    return permission.map((p) => user?.access?.permissions?.[p] ?? null);
  }

  return user?.access?.permissions?.[permission] ?? null;
}) as ((permission: UserPermission) => boolean | null) &
  ((permission: UserPermission[]) => Array<boolean | null>);

export default usePermission;
